import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../../../common/config";

export const changePasswordService = createApi({
  reducerPath: "change Password",
  baseQuery,
  endpoints: (builder) => ({
    changePassword: builder.mutation({
      query: (formdata) => ({
        url: `/api/users/changePassword/${formdata?.id}`,
        method: "PUT",
        body: formdata,
      }),
    }),
  }),
});
export const { useChangePasswordMutation } = changePasswordService;
